import ValidateEmailPromptModal from 'src/components/ValidateEmailPromptModal.svelte';
import { user_settings } from 'src/stores/account/user';
import type { ModalConfig } from 'src/types/Modals';
import { get } from 'svelte/store';
import { NoPremiumVoucherCheckRule } from './rules/NoPremiumVoucherRule';

// Feature toggle — flip to true to re-enable the blocking "Please validate your e-mail"
// modal. Kept intentionally for future security-sensitive flows (FE-1468).
const SHOW_UNVERIFIED_EMAIL_MODAL = false;

export const ValidateEmailPromptModalConfig: ModalConfig = {
	id: 'validatedMailState',
	component: ValidateEmailPromptModal,
	props: {
		priority: 100, // Highest priority
		showModal: true,
	},
	rules: [
		{
			check: () => SHOW_UNVERIFIED_EMAIL_MODAL,
			expected: true,
		},
		{
			check: () => get(user_settings).mail_validated === 0,
			expected: true,
		},
		NoPremiumVoucherCheckRule,
	],
};
